import { DataGrid, GridColDef, GridRowsProp, GridValidRowModel, GridRowIdGetter } from "@mui/x-data-grid";
import { Footer, Header, PageLayout } from "./PageLayout"

type Props<T extends GridValidRowModel> = {
  header: Header;
  footer?: Footer;
  children?: React.ReactNode;
  table: {
    data: GridRowsProp<T>;
    columns: readonly GridColDef<T>[];
    getRowKey: GridRowIdGetter<T>;

    tableContainerSx?: React.CSSProperties;
    tableSx?: React.CSSProperties;
    headerBackgroundColor?: string;
    emptyMessage?: string;

    ariaLabel?: string;
  }
}

export function TableLayout<T extends GridValidRowModel>({ header, footer, children, table }: Props<T>) { 

  return (
    <PageLayout
      header={header}
      body={<>
        <DataGrid
          rows={table.data}
          columns={table.columns}
          getRowId={table.getRowKey}
        />
        {children}
      </>}
      footer={footer}
    />
  );
}
